import {
    USER_INFO,
    // TOKEN
} from "../action-types/auth";

const initialState = {
  // user_info: null,
  user_info: JSON.stringify({first_name: '',
            last_name: '',
            role_ids: []}),
  // token: ''
}

const ReducerAuth = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_INFO:
      // console.log(payload)
      return {
        ...state,
        user_info: JSON.stringify(payload)
      };
    // case TOKEN:
    //   return {
    //     ...state,
    //     token: payload
    //   };
    default:
      return state;
  }
};

export default ReducerAuth;